import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/

  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CompanyId',
    field: FIELDS.COMPANY_ID,
    title: ' Company Id',
    label: 'CompanyId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CompanyName',
    field: FIELDS.COMPANY_NAME,
    title: ' Company Name',
    label: 'CompanyName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SourceId',
    field: FIELDS.SOURCE_ID,
    title: ' Source Id',
    label: 'SourceId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'SourceName',
    field: FIELDS.SOURCE_NAME,
    title: ' Source Name',
    label: 'SourceName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ReferenceId',
    field: FIELDS.REFERENCE_ID,
    title: ' Reference Id',
    label: 'ReferenceId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'RMAId',
    field: FIELDS.RMAID,
    title: ' RMAId',
    label: 'RMAId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'VendorRMAId',
    field: FIELDS.VENDOR_RMAID,
    title: ' Vendor RMAId',
    label: 'VendorRMAId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'SalesOrderId',
    field: FIELDS.SALES_ORDER_ID,
    title: ' Sales Order Id',
    label: 'SalesOrderId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'InvoiceId',
    field: FIELDS.INVOICE_ID,
    title: ' Invoice No',
    label: 'InvoiceId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PurchaseOrderId',
    field: FIELDS.PURCHASE_ORDER_ID,
    title: 'Purchase Order No',
    label: 'Purchase Order No',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PaymentId',
    field: FIELDS.PAYMENT_ID,
    title: ' Payment Id',
    label: 'PaymentId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Amount',
    field: FIELDS.AMOUNT,
    title: ' Amount',
    label: 'Amount',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Applied',
    field: FIELDS.APPLIED,
    title: ' Applied',
    label: 'Applied',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Balance',
    field: FIELDS.BALANCE,
    title: ' Balance',
    label: 'Balance',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'IsRefund',
    field: FIELDS.IS_REFUND,
    title: ' Is Refund',
    label: 'IsRefund',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Comment',
    field: FIELDS.COMMENT,
    title: ' Comment',
    label: 'Comment',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    cell: 'formatDate',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: ' Created By User Id',
    label: 'CreatedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: ' Created By User Full Name',
    label: 'CreatedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: ' Modified By User Id',
    label: 'ModifiedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: ' Modified By User Full Name',
    label: 'ModifiedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'SODate',
    field: FIELDS.SODATE,
    title: ' SODate',
    label: 'SODate',
    cell: 'formatDate',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CustomerPO',
    field: FIELDS.CUSTOMER_PO,
    title: ' Customer Purchase Order',
    label: 'Customer Purchase Order',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'PODate',
    field: FIELDS.PODATE,
    title: ' PODate',
    label: 'PODate',
    cell: 'formatDate',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
